/**
 * X-View 를 이번 프레임에 다시 그릴지 (44회차).
 *
 * 43회차까지는 가로축이 흐르도록 **매 프레임** 점 전부를 픽셀 버퍼에 다시 찍었다. 렌더러 실측으로
 * 3만 점이 한 프레임(16ms)이라, 5분 창에 100건/초만 들어와도 탭이 보이는 동안 코어 하나가 늘 찼다.
 * 과거 보기는 그림이 안 바뀌는데도 60fps 로 그렸다.
 *
 * 5분 창이 1,000px 이면 가로축은 0.3초에 1px 흐른다. 그래서 바뀐 것(받은 요청·거르기·기간·크기·
 * 배율)이 있거나 끄는 중일 때는 곧바로, 실시간 보기는 그 밖에도 250ms 마다 그린다.
 * 과거 보기는 바뀐 것이 없으면 그리지 않는다. 순수 함수라 시험한다.
 */

/** 실시간 보기에서 가로축 흐름을 보이려고 다시 그리는 간격 */
export const LIVE_REDRAW_MS = 250;

export function shouldRedraw(input: {
  /** 그림에 쓰이는 것이 마지막 그림 뒤로 바뀌었다 */
  dirty: boolean;
  /** 끄는 중이라 사각형이 따라와야 한다 */
  dragging: boolean;
  /** 오른쪽 끝이 지금인 실시간 보기 */
  live: boolean;
  /** 마지막으로 그린 뒤 지난 시간 */
  sinceLastMs: number;
}): boolean {
  if (input.dirty || input.dragging) return true;
  return input.live && input.sinceLastMs >= LIVE_REDRAW_MS;
}
